import React from 'react';
import './StatusHistory.css';

function StatusHistory({ statusHistory = [] }) {
  if (!statusHistory || statusHistory.length === 0) {
    return (
      <div className="status-history">
        <h4>Status History</h4>
        <p className="no-history">No status changes yet</p>
      </div>
    );
  }

  return (
    <div className="status-history">
      <h4>Status History</h4>
      <div className="history-timeline">
        {statusHistory.map((entry, index) => (
          <div key={index} className="history-entry">
            <div className={`history-status ${entry.status}`}>
              {entry.status.charAt(0).toUpperCase() + entry.status.slice(1)}
            </div>
            <div className="history-details">
              <div className="history-action">
                <strong>{entry.status === 'approved' ? 'Approved' : entry.status === 'rejected' ? 'Rejected' : 'Submitted'}</strong>
                {' by '}
                <span className="history-user">
                  {entry.changedByName}
                </span>
              </div>
              <div className="history-email">
                {entry.changedByEmail}
              </div>
              <div className="history-timestamp">
                {new Date(entry.changedAt).toLocaleString()}
              </div>
              {entry.reason && (
                <div className="history-reason">
                  <strong>Reason:</strong> {entry.reason}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default StatusHistory;
